<template>
  <div class="main-page">
    <div class="humberger-icon" @click="openToggle">
      <label class="sidebarIconToggle">
        <div class="spinner diagonal part-1" :class="{ diagonaltop: status }"></div>
        <div class="spinner horizontal" :class="{ centerLine: status }"></div>
        <div class="spinner diagonal part-2" :class="{ diagonalbottom: status }"></div>
      </label>
    </div>
    <div class="sidebar-wrap" id="sidebarManu" :class="{ active: status }">
      <Sidebar v-if="checkRole == 3" />
      <SidebarAdmin v-else-if="checkRole == 5 || checkRole == 6 || checkRole == 2" />
      <SidebarBank v-else-if="checkRole == 13" />
      <sidebar-super-admin v-else />
    </div>

    <div class="dashboard">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar";
import SidebarAdmin from "./admin/SidebarAdmin";
import SidebarBank from "./admin/SidebarBank.vue";
import SidebarSuperAdmin from "./superAdmin/SidebarSuperAdmin.vue";

export default {
  components: {
    Sidebar,
    SidebarAdmin,
    SidebarBank,
    SidebarSuperAdmin,
  },
  data() {
    return {
      status: false,
    };
  },
  computed: {
    checkRole() {
      let role = localStorage.getItem("role");
      if (role) {
        return role;
      } else {
        return null;
      }
    },
  },

  methods: {
    openToggle() {
      this.status = !this.status;
    },
  },
};
</script>

<style scoped>
.main-page {
  display: flex;
  align-items: stretch;
  height: 100%;
}
.dashboard {
  padding: 30px;
  width: 100%;
}

.sidebar-wrap {
  width: 219px;
  border-right: solid 1px rgba(112, 112, 112, 0.4);
  box-shadow: 3px 0 6px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: transform 0.8s linear;
  -moz-transition: transform 0.8s linear;
  -o-transition: transform 0.8s linear;
  -ms-transition: transform 0.8s linear;
  transition: transform 0.8s linear;
}

.humberger-icon {
  display: none;
}

.sidebarIconToggle {
  transition: all 0.3s;
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  z-index: 99;
  height: 100%;
  width: 100%;
  height: 22px;
  width: 22px;
}
.spinner {
  transition: all 0.3s;
  box-sizing: border-box;
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: #6454f0;
}

.horizontal {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  margin-top: 3px;
}
.diagonal.part-1 {
  position: relative;
  transition: all 0.3s;
  box-sizing: border-box;
  float: left;
}
.diagonal.part-2 {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  margin-top: 3px;
}

input[type="checkbox"] {
  transition: all 0.3s;
  box-sizing: border-box;
  display: none;
}

/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .centerLine {
  transition: all 0.3s;
  box-sizing: border-box;
  opacity: 0;
}
/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .diagonaltop {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(135deg);
  margin-top: 8px;
}
/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .diagonalbottom {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(-135deg);
  margin-top: -9px;
}

@media (max-width: 768px) {
  .humberger-icon {
    display: block;
    position: absolute;
    left: 240px;
    top: 24px;
    height: 22px;
    width: 22px;
  }

  .sidebar-wrap {
    display: none;
    /* transform: translateX(-264px); */
    -webkit-transition: transform 0.8s linear;
    -moz-transition: transform 0.8s linear;
    -o-transition: transform 0.8s linear;
    -ms-transition: transform 0.8s linear;
    transition: transform 0.8s linear;
    animation: slide-right 0.4s linear;
  }

  .active {
    /* transform: translateX(0); */
    display: block;
    width: 318px;
    -webkit-transition: transform 0.8s linear;
    -moz-transition: transform 0.8s linear;
    -o-transition: transform 0.8s linear;
    -ms-transition: transform 0.8s linear;
    transition: transform 0.8s linear;
    animation: slide-right 0.4s linear;
  }

  @keyframes slide-right {
    from {
      opacity: 0;
      transform: translateX(-264px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
</style>
